import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail'
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm'

/**
 * Per requirement GP-11, this provides a detailed view of a calculation product result
 **/
export const CalcProdResDetail = () => {
  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <EntityForm /> },
  ]

  return (
    <EntityDetail tabSpecs={tabSpecs} />
  )
}